var map = {
	"./sdc-actions.constant.ts": 434,
	"./sdc-actions.service.ts": 843,
	"./sdc-flux.module.ts": 383,
	"./sdc-store-school-channel.service.ts": 2086,
	"./sdc-store-validator.service.ts": 2087,
	"./sdc-store.interface.ts": 1271,
	"./sdc-store.service.ts": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2085;